import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { SupportDetailedQuestion } from '../components/support/SupportDetailedQuestion';
import { SupportListQuestion } from '../components/support/SupportListQuestion';
import SupportListItems from '../components/support/support-list/SupportListItems';

const SupportNavigation = () => {
  const supportNavigation = [
    {
      path: '/',
      element: <SupportListItems />,
      key: 'support-lists'
    },
    {
      path: '/detailed-question',
      element: <SupportDetailedQuestion />,
      key: 'detailed-question'
    },
    {
      path: '/questions',
      element: <SupportListQuestion />,
      key: 'support-list-question'
    }
  ];

  return (
    <Routes>
      {supportNavigation.map((route) => (
        <Route key={route.key} path={route.path} element={route.element} />
      ))}
    </Routes>
  );
};

export default SupportNavigation;
